/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from 'formik'
import { Category } from './category'
import { SubCategory } from './subcategory'
import Grid from '@mui/material/Grid'
import { toast } from 'react-toastify'
import Button from "@mui/material/Button"
import * as api from '../../../services/api'
import { useParams, useNavigate } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import TextField from '@mui/material/TextField'
import { useCore } from "../../../hooks/useCore"
import DeleteIcon from '@mui/icons-material/Delete'
import { formatMoney } from "../../../utils/format-money"
import { useEffect, useLayoutEffect, useState, useMemo } from 'react'
import { ListProductApiFallbackProps, ProductApiFallbackProps, RetrieveProductProps } from '../../../types/product'
import { LoadingPage } from "../../../components/LoadingPage"
import ModalConfirmWithText from "../../../components/ModalConfirmWithText"
import { ApiProps, ListAllApiProps } from "../../../types/api"
import { ListReportTemplateProps, ReportTemplateProps } from '../../../types/reportTemplate'
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices'
import { Alert, Avatar, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, InputAdornment, InputLabel, List, ListItem, ListItemAvatar, ListItemButton, ListItemSecondaryAction, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { ListParameter, ParameterProps } from '../../../types/parameter'
import { LooseObject } from '../../../types/core'
import { inputValueType, notTextOrNumber } from '../../Api/CreateOrUpdateApi/value_type'
import { handleFileRead } from '../../../utils/get-base64'
import CheckIcon from '@mui/icons-material/Check'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import ImageIcon from '@mui/icons-material/Image'

interface Values {
  name: string
  category: string
  subcategory: string
  description: string
  price: number
  match_price: number
  allow_processing: boolean
  background: boolean
  extrato_enabled: boolean
  report_template: string | null
}

interface DataProps extends Values {
  apis: string[]
  is_default_web: boolean
}

const initialValues: Values = {
  name: '',
  category: '',
  subcategory: '',
  description: '',
  price: 0,
  allow_processing: false,
  match_price: 0,
  background: false,
  extrato_enabled: false,
  report_template: ''
}

export default function CreateOrUpdateProduct(): JSX.Element {
  let { id } = useParams()
  const { setTitleBar, setPathTitleBar } = useCore()

  const [category, setCategory] = useState<string>("1")
  const [subcategory, setSubcategory] = useState<string>("")
  const [apiSelected, setApiSelected] = useState<string>("")
  const [apiList, setApiList] = useState<ApiProps[]>([])
  const [itemList, setItemList] = useState<ApiProps[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [reportTemplates, setReportTemplates] = useState<ReportTemplateProps[]>([])

  // --- seção de PACOTE WEB PADRÃO ---
  const [isDefaultWeb, setIsDefaultWeb] = useState<boolean>(false)
  const [defaultWebModalOpen, setDefaultWebModalOpen] = useState<boolean>(false)

  // --- seção de FALLBACK ENTRE APIs DO PRODUTO ---
  const [fallbackLinks, setFallbackLinks] = useState<ProductApiFallbackProps[]>([])
  const [fallbackRootSelected, setFallbackRootSelected] = useState<string>("")
  const [fallbackApiSelected, setFallbackApiSelected] = useState<string>("")
  const [fallbackBusy, setFallbackBusy] = useState<boolean>(false)

  // --- seção de CONSULTA PELO PRODUTO ---
  const navigate = useNavigate()
  const [awaitingConsult, setAwaitingConsult] = useState<boolean>(false)
  const [prodParams, setProdParams] = useState<ParameterProps[]>([])
  const [prodParamsRequired, setProdParamsRequired] = useState<string[]>([])
  const [prodInitialValues, setProdInitialValues] = useState<LooseObject>({})
  const [prodOriginalParameters, setProdOriginalParameters] = useState<ParameterProps[]>([])
  
  const { handleChange, handleSubmit, values, errors, setFieldValue, touched } =  useFormik({
    initialValues: initialValues,
    onSubmit: createOrUpdateProduct,
  })

  const {
    handleChange: handleConsultChange,
    handleSubmit: handleConsultSubmit,
    values: consultValues,
    setFieldValue: setConsultFieldValue,
  } = useFormik({
    initialValues: prodInitialValues,
    enableReinitialize: true,          // importante para recarregar quando buscar parâmetros
    onSubmit: createCallFromProduct
  })

  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value)
  }

  const handleSubCategoryChange = (event: SelectChangeEvent) => {
    setSubcategory(event.target.value)
  }

  const handleApiSelectedChange = (event: SelectChangeEvent) => {
    setApiSelected(event.target.value)
  }

  function handleDefaultWebCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      setDefaultWebModalOpen(true)
    } else {
      setIsDefaultWeb(false)
    }
  }

  function confirmDefaultWebActivation() {
    setIsDefaultWeb(true)
    setDefaultWebModalOpen(false)
  }

  function buildProductPayload(): DataProps {
    let data: DataProps = {...values, apis: [], is_default_web: isDefaultWeb}
    data.price = formatMoney(values.price.toString())
    data.match_price = formatMoney(values.match_price.toString())
    data.report_template = values.report_template || null
    data.category = category
    data.subcategory = subcategory
    // eslint-disable-next-line array-callback-return
    itemList.forEach((item) => {
      data.apis.push(item.id)
    })
    return data
  }

  async function createOrUpdateProduct() {
    if (itemList.length === 0) {
      return toast.error("Você precisa adicionar pelo menos uma API primeiro.", {
        position: toast.POSITION.TOP_RIGHT
      })
    }

    if (values.extrato_enabled && !values.report_template) {
      return toast.error("Selecione um template de extrato ou desmarque \"gera extrato em PDF\".", {
        position: toast.POSITION.TOP_RIGHT
      })
    }

    let data: DataProps = buildProductPayload()

    if (id) {
      toast.loading("Atualizando...", {
        position: toast.POSITION.TOP_RIGHT,
      })

      var resUpdated = await api.put(`product/update/${id}/`, data) as {[key:string]: any}
      
      toast.dismiss()
      
      if (resUpdated.status === 200) {
        toast.success("Dados atualizados com sucesso!", {
          position: toast.POSITION.TOP_RIGHT
        })
      } else {
        toast.error("Ops.. Tivemos um problema, por favor tente novamente mais tarde!", {
          position: toast.POSITION.TOP_RIGHT
        })
      }
    } else {
      toast.loading("Cadastrando...", {
        position: toast.POSITION.TOP_RIGHT,
      })

      var resCreated = await api.post('product/create/', data) as {[key:string]: any}

      toast.dismiss()
  
      if (resCreated.status === 201) {
        toast.success("Produto cadastrado com sucesso!", {
          position: toast.POSITION.TOP_RIGHT
        })
      } else {
        toast.error("Ops.. Tivemos um problema, por favor tente novamente mais tarde!", {
          position: toast.POSITION.TOP_RIGHT
        })
      }
    }
  }

  function addApiToProduct() {
    const _api = apiList?.filter((item) => item.id.indexOf(apiSelected) > -1)

    if (itemList.filter((item) => item.id.indexOf(apiSelected) > -1).length > 0) {
      return toast.error("Você já adicionou essa API ao produto", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else {
      setItemList([...itemList, _api[0]])
    }
  }

  function removeApiToProduct(id: string) {
    let items = itemList.filter((item) => item.id !== id)
    setItemList(itemList => items)
  }

  const getApis = async () => {
    const response = await api.get(`api/list/all/?category=1`) as ListAllApiProps
    setApiList(response.content)
    setApiSelected(response.content[0].id)
    if (!id) setLoading(false)
  }

  const getReportTemplates = async () => {
    const MAX_PAGES = 50
    let allResults: ReportTemplateProps[] = []
    let page = 1
    let hasNext = true

    while (hasNext && page <= MAX_PAGES) {
      const url = page === 1 ? 'product/report-template/list/' : `product/report-template/list/?page=${page}`
      const response = await api.get(url) as ListReportTemplateProps
      allResults = allResults.concat(response.content.results)
      hasNext = response.content.next !== null
      page += 1
    }

    setReportTemplates(allResults)
  }

  const getFallbackLinks = async () => {
    if (!id) return
    const response = await api.get(`product/api-fallback/list/${id}/`) as ListProductApiFallbackProps
    setFallbackLinks(response.content)
  }

  async function addFallbackLink() {
    if (fallbackBusy) return
    if (!fallbackRootSelected || !fallbackApiSelected) {
      return toast.error("Selecione a API raiz e a API de fallback.", {
        position: toast.POSITION.TOP_RIGHT
      })
    }

    setFallbackBusy(true)
    const response: any = await api.post('product/api-fallback/create/', {
      product: id,
      root_api: fallbackRootSelected,
      fallback_api: fallbackApiSelected,
    })

    if (response.status === 201) {
      toast.success("Fallback cadastrado com sucesso!", { position: toast.POSITION.TOP_RIGHT })
      setFallbackApiSelected("")
      await getFallbackLinks().catch(console.error)
    } else {
      const message = response.data?.non_field_errors?.[0] || response.data?.detail || "Não foi possível cadastrar esse fallback."
      toast.error(message, { position: toast.POSITION.TOP_RIGHT })
    }
    setFallbackBusy(false)
  }

  async function removeFallbackLink(linkId: string) {
    if (fallbackBusy) return
    setFallbackBusy(true)
    const response: any = await api.destroy(`product/api-fallback/destroy/${linkId}/`)
    if (response.status === 204) {
      await getFallbackLinks().catch(console.error)
    } else {
      toast.error("Não foi possível remover esse fallback.", { position: toast.POSITION.TOP_RIGHT })
    }
    setFallbackBusy(false)
  }

  const getProduct = async () => {
    const response = await api.get(`product/retrieve/${id}/`) as RetrieveProductProps
    setCategory(response.content.category)
    setSubcategory(response.content.subcategory)
    setFieldValue('name', response.content.name)
    setFieldValue('category', response.content.category)
    setFieldValue('subcategory', response.content.subcategory || "1")
    setFieldValue('price', response.content.price__display)
    setFieldValue('background', response.content.background)
    setFieldValue('description', response.content.description)
    setFieldValue('match_price', response.content.match_price__display)
    setFieldValue('allow_processing', response.content.allow_processing)
    setFieldValue('extrato_enabled', response.content.extrato_enabled ?? false)
    setFieldValue('report_template', response.content.report_template || '')
    setIsDefaultWeb(response.content.is_default_web ?? false)

    let a = []

    for (let i=0; i<apiList.length; i++) {
      if (response.content.apis.indexOf(apiList[i].id) > -1) {
        a.push(apiList[i])
      } 
    }

    if (a.length > 0) setItemList([...itemList, ...a])
    setLoading(false)
  }
  
  useEffect(() => {
    if (id) {
      if (values.name.length > 0) {
        setTitleBar(`Produto - ${values.name}`)
      }
      getProduct().catch(console.error)
      getProductParameters()
      getFallbackLinks().catch(console.error)
    } else {
      setTitleBar('Novo produto')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiList])

  useEffect(() => {
    getApis().catch(console.error)
    getReportTemplates().catch(console.error)
	}, [])

  useLayoutEffect(() => {
    setPathTitleBar(undefined)
  }, [setPathTitleBar])

  async function getProductParameters() {
    if (!id) return
    setLoading(true)

    const response = await api.patch('product/list/parameters/', { products_id: [id] }) as { [k: string]: any }
    const parametersResponse = response.data as ListParameter

    setProdOriginalParameters(parametersResponse.content as ParameterProps[])
    // deduplicar por descrição (mesma lógica do Dashboard)
    const seenDescriptions: string[] = []
    const requiredDescriptions: string[] = []
    const params: ParameterProps[] = []
    const initVals: LooseObject = {}

    parametersResponse.content.forEach((p: ParameterProps) => {
      // campo inicial
      initVals[`${p.name}|${p.api_id}`] = ''
      // adicionar uma única vez por descrição
      if (seenDescriptions.indexOf(p.description) === -1) {
        seenDescriptions.push(p.description)
        params.push(p)
      }
      if (p.required && requiredDescriptions.indexOf(p.description) === -1) {
        requiredDescriptions.push(p.description)
      }
    })

    setProdParams(params)
    setProdParamsRequired(requiredDescriptions)
    setProdInitialValues(initVals)
    setLoading(false)
  }

  async function createCallFromProduct() {
    if (!id) return
    setAwaitingConsult(true)
    toast.loading("Aguarde...", { position: toast.POSITION.TOP_RIGHT })

    // monta payload com os parâmetros (mesma lógica do Dashboard)
    const data: any = {
      products: [id],
      bypass_cache: true,  // << obrigatório: força caminho do fornecedor
      data: {}
    }

    const _params: LooseObject = {}
    prodOriginalParameters.forEach((originalItem: ParameterProps) => {
     prodParams.forEach((item: ParameterProps) => {
       if (item.description === originalItem.description) {
         const keyOriginal = `${originalItem.name}|${originalItem.api_id}`
         const keyShown = `${item.name}|${item.api_id}`
         const val = consultValues[keyShown]
         _params[keyOriginal] = {
           value: (!val && item.value_type === "3")
             ? item.boolean_default
             : (val ?? '')
         }
       }
     })
    })
    data.data = _params

    const response = await api.post('call/create/', data) as { [k: string]: any }

    setAwaitingConsult(false)
    toast.dismiss()

    // Redireciona se vier ID; se não, mensagem igual à do Dashboard
    const newId = response?.data?.content?.id
    if (response.status === 201 && newId) {
      toast.success("Sucesso 😃! Redirecionando para a consulta...", { position: toast.POSITION.TOP_RIGHT })
      setTimeout(() => navigate(`/query/${newId}`), 1500)
    } else if (response.status === 200 && newId) {
      // se o backend retornar id mesmo em 200, redirecione
      toast.success("Consulta em processamento. Redirecionando...", { position: toast.POSITION.TOP_RIGHT })
      setTimeout(() => navigate(`/query/${newId}`), 1500)
    } else if (response.status === 200) {
      // fallback (webhook, sem id)
      toast.success("Sua consulta será processada. Acompanhe em Consultas.", { position: toast.POSITION.TOP_RIGHT })
    } else {
      toast.error("Ops.. Tivemos um problema, por favor tente novamente mais tarde!", { position: toast.POSITION.TOP_RIGHT })
    }
  }

  const hasCacheEnabled = useMemo(
    () => itemList.length > 0 && itemList.every(api => api?.cache_enabled === true),
    [itemList]
  )


	return (
		<>
      <ToastContainer />
      <ModalConfirmWithText
        open={defaultWebModalOpen}
        description={`Isso vai marcar o produto "${values.name}" como disponível no pacote padrão para os clientes Web.`}
        confirmationValue={values.name}
        confirmLabel="Confirmar"
        handleModalClose={() => setDefaultWebModalOpen(false)}
        handleConfirm={confirmDefaultWebActivation}
      />
      {
        !loading
          ? <> 
              <form onSubmit={handleSubmit}>
                  <Grid 
                    container 
                    spacing={2} 
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid 
                      item 
                      md={12} xs={12}
                    >
                      <h3>Dados básicos</h3>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        fullWidth
                        required={true}
                        id="name"
                        name="name"
                        label="Nome"
                        value={values.name}
                        onChange={handleChange}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="category-label">Categoria</InputLabel>
                        <Select
                          fullWidth
                          required={true}
                          labelId="category-label"
                          id="category"
                          name="category"
                          value={category}
                          label="Categoria"
                          onChange={handleCategoryChange}
                        >
                          {Category?.map((item) => (
                            <MenuItem key={`category-${item.id}-menu-item`} value={item.id}>{item.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {category === "5" && (
                      <Grid item md={6} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="subcategory-label">Sub Categoria</InputLabel>
                          <Select
                            fullWidth
                            required={true}
                            labelId="subcategory-label"
                            id="subcategory"
                            name="subcategory"
                            value={subcategory}
                            label="Sub Categoria"
                            onChange={handleSubCategoryChange}
                          >
                            {SubCategory?.map((item) => (
                              <MenuItem key={`subcategory-${item.id}-menu-item`} value={item.id}>{item.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item md={12} xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        id="description"
                        name="description"
                        label="Descrição"
                        value={values.description}
                        onChange={handleChange}
                        error={touched.description && Boolean(errors.description)}
                        helperText={touched.description && errors.description}
                      />
                    </Grid>
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox 
                              name="allow_processing"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldValue("allow_processing", true)
                                } else {
                                  setFieldValue("allow_processing", false)
                                }
                              }}
                              checked={values.allow_processing}
                              value={values.allow_processing}
                            />
                          }
                          label="Permitir que esse produto seja disponibilizado para processamento em lote"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid 
                      item 
                      md={12} xs={12}
                    >
                      <h3>APIs</h3>
                    </Grid>
                    <Grid item md={10} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="api-label">API</InputLabel>
                        <Select
                          fullWidth
                          labelId="api-label"
                          id="api"
                          name="api"
                          value={apiSelected}
                          label="API"
                          onChange={handleApiSelectedChange}
                        >
                          {apiList?.map((item) => (
                            <MenuItem key={`api-list-${item.id}-menu-item`} value={item.id}>{item.name} ({item.provider_name})</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid 
                      item 
                      md={2} xs={12}
                      alignItems="center" 
                      alignContent="center"
                    >
                      <Button 
                        variant="contained" 
                        size="large" 
                        color="success" 
                        type="button"
                        onClick={() => {addApiToProduct()}}
                        fullWidth
                      >
                        Adicionar
                      </Button>
                    </Grid>
                    <Grid 
                      item 
                      md={12} xs={12}
                    >
                      <p>Abaixo é listado as APIs que fazem parte do seu produto (a ordem adicionada será a ordem de execução)</p>
                    </Grid>
                    <List dense disablePadding sx={{ width: '100%' }}>
                      {
                        itemList.length > 0 
                        ? itemList.map((item) => (
                            <ListItem 
                              key={`${item.id}-item-a`}
                              disablePadding 
                            >
                              <ListItemButton key={`${item.id}-item-b`}>
                                <ListItemAvatar key={`${item.id}-avatar`}>
                                  <Avatar>
                                    <ElectricalServicesIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText key={`${item.id}-text`} primary={`${item.name} (${item.provider_name})`} secondary={item.description} />
                              </ListItemButton>
                              <ListItemSecondaryAction key={`${item.id}-secondary`}>
                                <IconButton edge="end" aria-label="delete" onClick={() => {removeApiToProduct(item.id)}}>
                                  <DeleteIcon />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                          ))
                        : <></>
                      }
                    </List>
                    {id && (
                      <>
                        <Grid item md={12} xs={12} style={{ marginTop: 16 }}>
                          <h3>Fallback entre APIs deste produto</h3>
                          <p>Quando a API raiz falhar (conforme a "Regra de Falha" cadastrada nela), a(s) API(s) de fallback disparam junto — só vale pras APIs listadas acima, nesse produto.</p>
                        </Grid>
                        {itemList.length < 2 ? (
                          <Grid item md={12} xs={12}>
                            <Alert severity="info">Adicione pelo menos 2 APIs ao produto pra poder configurar um fallback entre elas.</Alert>
                          </Grid>
                        ) : (
                          <>
                            <Grid item md={5} xs={12}>
                              <FormControl fullWidth>
                                <InputLabel id="fallback-root-label">API raiz</InputLabel>
                                <Select
                                  fullWidth
                                  labelId="fallback-root-label"
                                  value={fallbackRootSelected}
                                  label="API raiz"
                                  onChange={(e: SelectChangeEvent) => {
                                    setFallbackRootSelected(e.target.value)
                                    setFallbackApiSelected("")
                                  }}
                                >
                                  {itemList.map((item) => (
                                    <MenuItem key={`fallback-root-${item.id}`} value={item.id}>{item.name} ({item.provider_name})</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item md={5} xs={12}>
                              <FormControl fullWidth disabled={!fallbackRootSelected}>
                                <InputLabel id="fallback-api-label">Dispara junto quando a raiz falhar</InputLabel>
                                <Select
                                  fullWidth
                                  labelId="fallback-api-label"
                                  value={fallbackApiSelected}
                                  label="Dispara junto quando a raiz falhar"
                                  onChange={(e: SelectChangeEvent) => setFallbackApiSelected(e.target.value)}
                                >
                                  {itemList.filter((item) => item.id !== fallbackRootSelected).map((item) => (
                                    <MenuItem key={`fallback-api-${item.id}`} value={item.id}>{item.name} ({item.provider_name})</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item md={2} xs={12} alignItems="center" alignContent="center">
                              <Button
                                variant="contained"
                                size="large"
                                color="success"
                                type="button"
                                onClick={() => { addFallbackLink() }}
                                disabled={fallbackBusy}
                                fullWidth
                              >
                                Adicionar
                              </Button>
                            </Grid>
                          </>
                        )}
                        <List dense disablePadding sx={{ width: '100%' }}>
                          {fallbackLinks.map((link) => (
                            <ListItem key={`${link.id}-fallback-item`} disablePadding>
                              <ListItemButton key={`${link.id}-fallback-item-b`}>
                                <ListItemText
                                  key={`${link.id}-fallback-text`}
                                  primary={`${link.root_api_name} → dispara junto: ${link.fallback_api_name}`}
                                />
                              </ListItemButton>
                              <ListItemSecondaryAction key={`${link.id}-fallback-secondary`}>
                                <IconButton edge="end" aria-label="delete" disabled={fallbackBusy} onClick={() => { removeFallbackLink(link.id) }}>
                                  <DeleteIcon />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                          ))}
                        </List>
                      </>
                    )}
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="background"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldValue("background", true)
                                } else {
                                  setFieldValue("background", false)
                                }
                              }}
                              value={values.background}
                              checked={values.background}
                            />
                          }
                          label="Alguma API possui retorno por webhook?"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="extrato_enabled"
                              onChange={(e) => {
                                setFieldValue("extrato_enabled", e.target.checked)
                                if (!e.target.checked) {
                                  setFieldValue("report_template", "")
                                }
                              }}
                              checked={values.extrato_enabled}
                            />
                          }
                          label="Este produto gera extrato em PDF?"
                        />
                      </FormGroup>
                    </Grid>
                    {values.extrato_enabled && (
                      <Grid item md={12} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="report-template-label">Template de extrato</InputLabel>
                          <Select
                            fullWidth
                            labelId="report-template-label"
                            id="report_template"
                            name="report_template"
                            value={values.report_template}
                            label="Template de extrato"
                            onChange={handleChange}
                          >
                            <MenuItem value="">Nenhum</MenuItem>
                            {reportTemplates?.map((item) => (
                              <MenuItem key={`report-template-${item.id}-menu-item`} value={item.id}>
                                {item.name} ({item.version})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <h3>Preço</h3>
                      <p>Defina abaixo o preço padrão deste produto</p>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <TextField
                        fullWidth
                        required={true}
                        id="price"
                        name="price"
                        label="Preço"
                        value={values.price}
                        onChange={handleChange}
                        error={touched.price && Boolean(errors.price)}
                        helperText={touched.price && errors.price}
                        InputLabelProps={{
                          shrink: true
                        }}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                      />
                    </Grid>
                    <Grid 
                      item 
                      md={12} xs={12}
                    >
                      <h3>Preço do match</h3>
                      <p>Defina abaixo o preço padrão do match deste produto</p>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <TextField
                        fullWidth
                        id="match_price"
                        label="Preço"
                        required={true}
                        name="match_price"
                        value={values.match_price}
                        onChange={handleChange}
                        error={touched.match_price && Boolean(errors.match_price)}
                        helperText={touched.match_price && errors.match_price}
                        InputLabelProps={{
                          shrink: true
                        }}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <h3>Pacote web padrão</h3>
                      <p>Defina se este produto pode ser incluído no pacote padrão oferecido aos clientes Web.</p>
                    </Grid>
                    <Grid
                      item
                      md={12} xs={12}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="is_default_web"
                              checked={isDefaultWeb}
                              onChange={handleDefaultWebCheckboxChange}
                            />
                          }
                          label="Permitir que este produto seja disponibilizado no pacote padrão para clientes Web"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid
                      item
                      alignItems="center"
                      alignContent="center"
                    >
                      <Button variant="contained" size="large" color="success" type="submit">
                        { id ? 'Atualizar' : 'Cadastrar'}
                      </Button>
                    </Grid>
                  </Grid>
                </form>

                {id && hasCacheEnabled && (
                  <Grid item md={12} xs={12} sx={{ mt: 6 }}>
                    <h3>Consulta de atualização de Cache</h3>
                    <p>
                      Execute uma consulta deste produto para atualizar o cache de alguma consulta.
                    </p>

                    <form onSubmit={handleConsultSubmit}>
                      <Grid container spacing={2}>
                        <Grid item md={12} xs={12}>
                          <Alert severity="info" sx={{ alignItems: 'center' }}>
                            <strong>Parâmetros do produto</strong>
                          </Alert>
                        </Grid>

                        {prodParams.map((parameter: ParameterProps) => (
                          <Grid key={`prod-param-${parameter.name}-${parameter.api_id}`} item md={12} xs={12}>
                            {
                              // texto/numero/data/etc (igual dashboard)
                              notTextOrNumber.indexOf(parameter.value_type) === -1 ? (
                                <TextField
                                  fullWidth
                                  label={parameter.description}
                                  type={inputValueType[parameter.value_type]}
                                  required={prodParamsRequired.indexOf(parameter.description) > -1}
                                  name={`${parameter.name}|${parameter.api_id}`}
                                  value={consultValues[`${parameter.name}|${parameter.api_id}`] ?? ''}
                                  onChange={handleConsultChange}
                                />
                              ) : parameter.value_type === '3' ? (
                                // booleano (igual dashboard)
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name={`${parameter.name}|${parameter.api_id}`}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setConsultFieldValue(`${parameter.name}|${parameter.api_id}`, parameter.boolean_value)
                                          } else {
                                            setConsultFieldValue(`${parameter.name}|${parameter.api_id}`, parameter.boolean_default)
                                          }
                                        }}
                                        checked={
                                          !!consultValues[`${parameter.name}|${parameter.api_id}`] &&
                                          consultValues[`${parameter.name}|${parameter.api_id}`] === parameter.boolean_value
                                        }
                                      />
                                    }
                                    label={parameter.description}
                                  />
                                </FormGroup>
                              ) : (
                                // arquivos: imagem/pdf/outros — base64 (igual dashboard)
                                <FormGroup>
                                  <label
                                    className={`label-input-file ${consultValues[`${parameter.name}|${parameter.api_id}`] ? "label-input-file-success" : "label-input-file-default"}`}
                                    htmlFor={`prod-${parameter.name}|${parameter.api_id}`}
                                  >
                                    {parameter.value_type === '4'
                                      ? <ImageIcon />
                                      : parameter.value_type === '5'
                                        ? <PictureAsPdfIcon />
                                        : <UploadFileIcon />
                                    }{" "}
                                    {
                                      consultValues[`${parameter.name}|${parameter.api_id}`]
                                        ? consultValues[`${parameter.name}|${parameter.api_id}`]['filename']
                                        : `Clique aqui e ${parameter.description}${prodParamsRequired.indexOf(parameter.description) > -1 ? " *" : ""}`
                                    }
                                    <input
                                      style={{ display: "none" }}
                                      id={`prod-${parameter.name}|${parameter.api_id}`}
                                      type="file"
                                      name={parameter.name}
                                      onChange={async (e) => {
                                        if (e.target.files) {
                                          const base64 = await handleFileRead(e)   // <<< base64 como no Dashboard
                                          setConsultFieldValue(`${parameter.name}|${parameter.api_id}`, base64)
                                        } else {
                                          setConsultFieldValue(`${parameter.name}|${parameter.api_id}`, '')
                                        }
                                      }}
                                      accept={
                                        parameter.value_type === '4'
                                          ? 'image/*'
                                          : parameter.value_type === '5'
                                            ? 'application/pdf'
                                            : undefined
                                      }
                                    />
                                  </label>
                                </FormGroup>
                              )
                            }
                          </Grid>
                        ))}

                        <Grid item md={12} xs={12} textAlign="center" sx={{ mt: 1 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={awaitingConsult || prodParams.length === 0}
                          >
                            Consultar <CheckIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                )}
            </>
        : <LoadingPage />
      }
		</>
	)
}
